var React = require('react');
var createReactClass = require('create-react-class');

var Video = createReactClass({

	render: function () {
        return (
            <p className="video-wrap">
                <video src={this.props.video.fields.file.url} preload="metadata" controls>
                    <source type="video/mp4" src={this.props.video.fields.file.url} />
                    <a href={this.props.video.fields.file.url}>{this.props.video.fields.file.url}</a>
                </video>
            </p>
        );
    }
});

module.exports = Video;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/video.jsx